import { render, staticRenderFns } from "./FromWarehouseBlock.vue?vue&type=template&id=46b3e04e&scoped=true"
import script from "./FromWarehouseBlock.vue?vue&type=script&lang=js"
export * from "./FromWarehouseBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b3e04e",
  null
  
)

export default component.exports